import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_methods: {
    delivery: 'Bezorging',
    pickup: 'Afhalen',
  },
  asap: 'ASAP',
  unavailable: 'Niet beschikbaar',
  ready_in_time: 'Klaar over {{time}} min',
  locations: {
    [ORDER_METHODS.DELIVERY]: 'Bezorging naar {{address}}',
    [ORDER_METHODS.PICKUP]: 'Afhalen bij {{address}}',
  },
  buttons: {
    change: 'Wijzigen',
    see_hours: 'Openingstijden bekijken',
    change_location: 'Locatie wijzigen',
    change_time: 'Tijd wijzigen',
  },
};
